/** @deprecated - use named export instead */
export { IconLabel as default } from "./IconLabel";
export { IconLabel } from "./IconLabel";
